/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const totalStyle = {
  textAlign: "center",
  background: "#ddeff3",
  fontWeight: "bold",
  textAlign: "right",
  paddingRight: 20,
};

const titleStyle = {
  textAlign: "right",
  paddingRight: 20,
  background: "#ddeff3",
  fontWeight: "bold",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = [
  {
    value: 0,
    name: "value20",
  },
  {
    value: 0,
    name: "value21",
  },
  {
    value: 0,
    name: "value22",
  },
  {
    value: 0,
    name: "value23",
  },
  {
    value: 0,
    name: "value24",
  },
  {
    value: 0,
    name: "value25",
  },
  {
    value: 0,
    name: "value26",
  },
  {
    value: 0,
    name: "value27",
  },
  {
    name: "value28",
    value: 0,
  },
  {
    name: "value29",
    value: 0,
  },
  {
    name: "value30",
    value: 0,
  },
  {
    name: "value31",
    value: 0,
  },
  {
    name: "value32",
    value: 0,
  },
  {
    name: "value33",
    value: 0,
  },
  {
    name: "value34",
    value: 0,
  },
  {
    name: "value35",
    value: 0,
  },
  {
    name: "value36",
    value: 0,
  },
  {
    name: "value37",
    value: 0,
  },
  {
    name: "value38",
    value: 0,
  },
  {
    name: "value39",
    value: 0,
  },
  {
    name: "value40",
    value: 0,
  },
  {
    name: "value41",
    value: 0,
  },
  {
    name: "value42",
    value: 0,
  },
  {
    name: "value43",
    value: 0,
  },
  {
    name: "value44",
    value: 0,
  },
  {
    name: "value45",
    value: 0,
  },
  {
    name: "value46",
    value: 0,
  },
  {
    name: "value47",
    value: 0,
  },
  {
    name: "value48",
    value: 0,
  },
];

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, value };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4", maxWidth: 10 }}>
                STT
              </Td>
              <Td rowSpan={1} colSpan={3} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Đơn vị tính
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số tiền/Số người
              </Td>
            </tr>

            <tr>
              <Td rowSpan={4} style={{ textAlign: "center", fontWeight: 700 }}>
                1
              </Td>
              <Td colSpan={3} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Tổng thu nhập chịu thuế(TNCT) trong kỳ [20]=[21]+[23]
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[20]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>0</Td>
            </tr>

            <tr>
              <Td rowSpan={2} colSpan={1} style={{ textAlign: "center" }}>
                a
              </Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Tổng TNCT phát sinh tại Việt Nam
              </Td>
              <Td style={{ textAlign: "center" }}>[21]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[1].value} name="value21" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Trong đó tổng TNCT phát sinh tại Việt Nam được miễn giảm theo Hiệp định (nếu có)
              </Td>
              <Td style={{ textAlign: "center" }}>[22]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[2].value} name="value22" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>b</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Tổng TNCT phát sinh ngoài Việt Nam
              </Td>
              <Td style={{ textAlign: "center" }}>[23]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[3].value} name="value23" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center", fontWeight: 700 }}>2</Td>
              <Td colSpan={3} style={{ textAlign: "left", fontWeight: 700 }}>
                Số người phụ thuộc
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700 }}>[24]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700 }}>Người</Td>
              <Td style={{ textAlign: "right" }}>
                <InputTable value={data[4].value} name="value24" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td rowSpan={6} style={{ textAlign: "center" }}>
                3
              </Td>
              <Td colSpan={3} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Các khoản giảm trừ ([25]=[26]+[27]+[28]+[29]+[30])
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[25]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>Người</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>
                132.000.000
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>a</Td>
              <Td colSpan={2} style={{ textAlign: "left", background: "#ddeff3" }}>
                Cho bản thân cá nhân
              </Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>[26]</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>132.000.000</Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>b</Td>
              <Td colSpan={2} style={{ textAlign: "left", background: "#ddeff3" }}>
                Cho những người phụ thuộc được giảm trừ
              </Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>[27]</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0</Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>c</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Từ thiện, nhân đạo, khuyến học
              </Td>
              <Td style={{ textAlign: "center" }}>[28]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[8].value} name="value28" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>d</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Các khoản đóng bảo hiểm được trừ
              </Td>
              <Td style={{ textAlign: "center" }}>[29]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[9].value} name="value29" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>e</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Khoản đóng quỹ hưu trí tự nguyện được trừ
              </Td>
              <Td style={{ textAlign: "center" }}>[30]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[10].value} name="value30" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>4</Td>
              <Td colSpan={3} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Tổng thu nhập tính thuế [31]=[20]-[22]-[25]
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[31]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>0</Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>5</Td>
              <Td colSpan={3} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Tổng số thuế thu nhập cá nhân (TNCN) phát sinh trong kỳ
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[32]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>0</Td>
            </tr>

            <tr>
              <Td rowSpan={6} style={{ textAlign: "center" }}>
                6
              </Td>
              <Td colSpan={3} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Tổng số thuế đã nộp trong kỳ ([33]=[34]+[35]+[36]+[37]+[38]) {"\n"}Trong đó:
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[33]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>0</Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>a</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Số thuế đã khấu trừ tại tổ chức trả thu nhập
              </Td>
              <Td style={{ textAlign: "center" }}>[34]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[14].value} name="value34" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>b</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Số thuế đã nộp trong năm không qua tổ chức trả thu nhập
              </Td>
              <Td style={{ textAlign: "center" }}>[35]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[15].value} name="value35" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>c</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Số thuế đã nộp ở nước ngoài được trừ (nếu có)
              </Td>
              <Td style={{ textAlign: "center" }}>[36]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[16].value} name="value36" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>d</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Số thuế đã khấu trừ, đã nộp ở nước ngoài trùng do quyết toán vắt năm
              </Td>
              <Td style={{ textAlign: "center" }}>[37]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[17].value} name="value37" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>đ</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Số thuế đã nộp trong năm không qua tổ chức trả thu nhập trùng do quyết toán vắt năm
              </Td>
              <Td style={{ textAlign: "center" }}>[38]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[18].value} name="value38" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td rowSpan={3} style={{ textAlign: "center" }}>
                7
              </Td>
              <Td colSpan={3} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Tổng số thuế TNCN được giảm trong kỳ ([39]=[40-]+[41])
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[39]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>0</Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>a</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Số thuế phải nộp trùng do quyết toán vắt năm
              </Td>
              <Td style={{ textAlign: "center" }}>[40]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[20].value} name="value40" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center" }}>b</Td>
              <Td colSpan={2} style={{ textAlign: "left" }}>
                Tổng số thuế TNCN được giảm khác
              </Td>
              <Td style={{ textAlign: "center" }}>[41]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[21].value} name="value41" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>8</Td>
              <Td colSpan={3} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Tổng số thuế phải nộp trong kỳ [44]=([32]-[33]-[39]){">"}0
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[42]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>0</Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>9</Td>
              <Td colSpan={3} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Số thuế được miễn do cá nhân có số tiền thuế phải nộp sau quyết toán từ 50.000 đồng
                trở xuống (0{"<"}[42]{"<"}=50.000 đồng)
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[43]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>0</Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>10</Td>
              <Td colSpan={3} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Tổng số thuế nộp thừa trong kỳ [44]=([32]-[33]-[39]){"<"}0
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[44]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>0</Td>
            </tr>

            <tr>
              <Td rowSpan={4} style={{ textAlign: "center" }}>
                11
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", background: "#ddeff3" }}>
                a
              </Td>
              <Td colSpan={2} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Tổng số thuế đề nghị hoàn trả [45]=[46]+[47]
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[45]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>0</Td>
            </tr>

            <tr>
              <Td rowSpan={2}>Trong đó</Td>
              <Td style={{ textAlign: "left" }}> Số thuế hoàn trả cho người nộp thuế</Td>
              <Td style={{ textAlign: "center" }}>[46]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[26].value} name="value46" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "left" }}>Tổng số thuế TNCN được giảm khác</Td>
              <Td style={{ textAlign: "center" }}>[47]</Td>
              <Td style={{ textAlign: "center" }}>VNĐ</Td>
              <Td style={{ textAlign: "center" }}>
                <InputTable value={data[27].value} name="value47" onChange={handleChange} />
              </Td>
            </tr>

            <tr>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>b</Td>
              <Td colSpan={2} style={{ textAlign: "left", fontWeight: 700, background: "#ddeff3" }}>
                Tổng số thuế bù trừ cho các phát sinh của kỳ sau [48]=[44]-[45]
              </Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>[48]</Td>
              <Td style={{ textAlign: "center", fontWeight: 700, background: "#ddeff3" }}>VNĐ</Td>
              <Td style={{ textAlign: "right", fontWeight: 700, background: "#ddeff3" }}>0</Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { onChange, type = "text", name, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name, type });
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.2rem 0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
